<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">
        <a-form-item label="合同" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-spin :spinning="selectLoading">
            <a-select
              placeholder="请选择合同"
              name="contract_id"
              optionFilterProp="children"
              showSearch
              allow-clear
              v-decorator="['contract_id', { rules: [{ required: true, message: '请选择合同' }] }]"
            >
              <a-select-option v-for="d in selectList" :key="d.id">{{ d.name }}</a-select-option>
            </a-select>
          </a-spin>
        </a-form-item>
        <a-form-item label="客户" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-spin :spinning="customerLoading">
            <a-select
              placeholder="请选择客户"
              name="customer_id"
              showSearch
              optionFilterProp="children"
              allow-clear
              v-decorator="['customer_id', { rules: [{ required: true, message: '请选择客户' }] }]"
            >
              <a-select-option v-for="d in customerList" :key="d.id">{{ d.name }}</a-select-option>
            </a-select>
          </a-spin>
        </a-form-item>
        <a-form-item label="证书" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-spin :spinning="crtsLoading">
            <a-select
              placeholder="请选择证书"
              name="certificates"
              optionFilterProp="children"
              allow-clear
              v-decorator="['certificates', { rules: [{ required: true, message: '请选择证书' }] }]"
            >
              <a-select-option v-for="d in crtsList" :key="d.id.toString()">{{ d.title }}</a-select-option>
            </a-select>
          </a-spin>
        </a-form-item>
        <a-form-item label="数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            name="number"
            v-decorator="[
              'number',
              {
                initialValue: 1,
                rules: [{ required: true, message: '请输入数量' }]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="收款金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            name="money"
            v-decorator="[
              'money',
              {
                initialValue: 0,
                rules: [{ required: true, message: '请输入价格' }]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="收款日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            showTime
            name="date"
            format="YYYY-MM-DD"
            placeholder="请选择收款日期"
            v-decorator="['date', { rules: [{ required: true, message: '请选择收款日期' }] }]"
          />
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea rows="4" name="remark" placeholder="请输入备注信息" v-decorator="['remark', {}]" />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 20 }" style="text-align: center">
          <a-button :loading="formLoading" @click="handleSubmit(setFormData)" type="primary">提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { GoBack } from '@/components'
import { form, select } from '@/mixins'
const fields = ['customer_id', 'contract_id', 'certificates', 'number', 'remark', 'date', 'money']
const apiList = {
    getInfo: '/customers/incomes/',
    create: '/customers/incomes/create',
    update: '/customers/incomes/',
    selectList: '/customers/contracts/select',
    customerList: '/customers/select',
    crtsList: '/certificates/select'
}
export default {
    name: 'CustomerMemeberForm',
    mixins: [form, select],
    components: {
        GoBack
    },
    data () {
        return {
            apiList,
            fields,
            selectLoading: false, // 分类下拉加载
            selectList: [], // 分类下拉数据
            crtsLoading: false, // 课程下拉加载
            crtsList: [], // 课程下拉数据
            customerLoading: false,
            customerList: []
        }
    },
    mounted () {
        const that = this
        if (that.$route.params.id) {
            that.getFormData(that.$route.params.id, function (values) {
                values.money = values.money / 100
                values.date = that.moment(values.date)
            }) // 获取编辑信息
        }
        that.getSelectLists({
            url: apiList.selectList
        }) // 获取合同下拉列表
        that.getSelectLists({
            url: apiList.customerList,
            type: 'customerList',
            load: 'customerLoading'
        }) // 获取客户下拉列表
        that.getSelectLists({
            url: apiList.crtsList,
            type: 'crtsList',
            load: 'crtsLoading'
        }) // 获取客户下拉列表
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-05-06 12:09:12
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description: 整理表单数据
         * @param  {*}
         * @return {*}
         * @param {*} values
         */
        setFormData (values) {
            values.date = values.date.format('YYYY-MM-DD')
        }

    }
}
</script>
